<template>
    <div class="animated efficiency">

          <modal large title="" v-model="exportHistiryModal" effect="fade/zoom">
            <div slot="modal-header" class="modal-header">
            </div>
            <StatisticTable :headColumns="exportHeadColumns"
                            :footColumns="exportFootColumns"
                            :rows="exportRows"
                            :title="`${$t('statistic.payment_history')}`">
            </StatisticTable>
            <div slot="modal-footer" class="modal-footer">
                <button type="button" class="btn btn-outline-info" @click="exportHistiryModal = false">
                    {{ $t('verbs.close') }}
                </button>
            </div>
        </modal>

        <OrderTable
            :title="`${$t('pages.remnants')}`"
            :headColumns="headColumns"
            :footColumns="footColumns"
            :rows="rows"
            :disableActionBTN="true"
            :key="'order-table-remnants'"
            :isLoading="loading"
            @changeVal="changeVal"
            :idElem="'remnants'"
        >
        <template slot="table-actions">
          <button class="btn-close" @click="toggleExportHistoryModal()"><i class="fa fa-book"></i></button>
        </template>
        </OrderTable>
    </div>
</template>

<script>
  import Filters from '../../../components/Filters.vue'
  import Storage from '../../../api/Storage'
  import API from '../../../api/API'
  import { map, forEach, isEqual, orderBy } from 'lodash'
  import OrderTable from '../../../components/OrderTable'
  import StatisticTable from '../../../components/StatisticTable.vue'
  import Helper from '../../../api/Helper'
  import TypeColor from '../../../assets/TypeColor'
  import { modal } from 'vue-strap'

  export default {
    name: 'Remnants',
    components: {
      Filters,
      OrderTable,
      modal,
      StatisticTable
    },
    props: {
      rowRemnants: [Array, Object],
      loading: Boolean
    },
    data () {
      return {
        filtersScope: {
          dateFilter: true
        },
        Storage: Storage,
        TypeColor: TypeColor,
        Helper: Helper,
        country: null,
        headColumns: [
          {label: this.$root.$t('statistic.product'), field: 'product_id', width: '10%', widthTd: '10%'},
          {label: this.$root.$t('statistic.balance'), field: 'stock_balance', input: {type: 'number'}, width: '16%', widthTd: '16%'},
          {label: this.$root.$t('statistic.unloaded_leads'), field: 'count_lead', width: '10%', widthTd: '10%'},
          {label: this.$root.$t('statistic.unloaded_product'), field: 'count_product', width: '10%', widthTd: '10%'},
          {label: this.$root.$t('statistic.delays_leads'), field: 'count_stagnation_lead', color: [{value: '>0', bg: '#ef9a9a'}], width: '10%', widthTd: '10%'},
          {label: this.$root.$t('statistic.delays_product'), field: 'count_stagnation_product', color: [{value: '>0', bg: '#ef9a9a'}], width: '10%', widthTd: '10%'},
          {label: this.$root.$t('statistic.stock_product'), field: 'reserve', bg: {maxday: 45, colorBg: '#90caf9'}, width: '8%', widthTd: '8%'},
          {label: this.$root.$t('statistic.ordered'), field: 'is_ordered', color: [{value: 1, bg: '#53d3a2'}], width: '6%', widthTd: '6%'},
          {label: this.$root.$t('statistic.expiration_date'), field: 'expiration_date', width: '10%', widthTd: '10%'},
          {label: this.$root.$t('statistic.stagnation_date'), field: 'stagnation_date', width: '10%', widthTd: '10%'}
        ],
        rows: [],
        footColumns: {},
        exportHistiryModal: false,
        exportHeadColumns: [
          {label: this.$root.$t('statistic.user'), field: 'user'},
          {label: this.$root.$t('statistic.offer'), field: 'offer'},
          {label: this.$root.$t('statistic.date'), field: 'datetime'},
          {label: this.$root.$t('statistic.fix_from'), field: 'fix_from'},
          {label: this.$root.$t('statistic.fix_to'), field: 'fix_to'}
        ],
        exportRows: [],
        exportFootColumns: {}
      }
    },
    watch: {
      rowRemnants: function (newq, old) {
        if (!isEqual(newq, old)) {
          this.calculateRows(newq)
        }
      }
    },
    mounted () {
      this.calculateRows(this.rowRemnants)
      this.$root.$on('filters_load_new_data', () => {
        this.calculateRows(this.rowRemnants)
      })
    },
    methods: {
      changeVal (key, cell) {
        this.$emit('changeVal', { id: key, title: cell.key, value: cell.value })
      },
      calculateRows (rowRemnants) {
        this.rows = []
        map(rowRemnants, (item, index) => {
          const value = []
          forEach(this.headColumns, (headCol) => {
            if (Number(item[headCol.field])) {
              item[headCol.field] = parseInt(item[headCol.field])
            }
            let auxvalue = null
            if (headCol.field === 'count_product' || headCol.field === 'count_stagnation_product' || headCol.field === 'stock_balance') {
              if (item[headCol.field]) {
                auxvalue = 'шт.'
              }
            }
            value.push({
              key: headCol.field,
              input: headCol.input ? headCol.input : null,
              value: item[headCol.field],
              color: headCol.color ? headCol.color : null,
              width: headCol.width ? headCol.width : null,
              widthTd: headCol.widthTd ? headCol.widthTd : null,
              aux: auxvalue,
              bg: headCol.bg ? headCol.bg : null
            })
          })
          this.rows.push({
            key: index,
            value
          })
        })
        this.footColumns = {
        }
      },
      toggleExportHistoryModal () {
        if (!this.exportHistiryModal) {
          this.exportRows = []
          API.getRemnandsChanges().then((response) => {
            const orderedResponse = orderBy(response.body, ['date'], ['ASC'])
            orderedResponse.map((d) => {
              this.exportRows.push({
                user: {value: d.user, bg: true},
                offer: {value: Helper.getOfferTitle(Storage.offers, d.offer_id), bg: true},
                date: {value: d.datetime, bg: true},
                fix_from: {value: d.remnants_from, bg: true},
                fix_to: {value: d.remnants_to, bg: true}
              })
            })
            this.exportHistiryModal = true
          }).catch((response) => {
            this.$notify({
              type: 'danger',
              title: this.$root.$t('verbs.error'),
              text: response.body.message ? response.body.message : response.body,
              animationType: 'velocity'
            })
          })
        } else {
          this.exportHistiryModal = false
        }
        return false
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Remnants.vue?69ea44a7